module.exports = __webpack_public_path__ + "static/david1-f78f12c8c55356a365b5a73abc6f88b4.jpg";